export interface SiteNavItem {
  key: string;
  label: string;
  path: string;
  children?: SiteNavItem[];
}

export const SITE_NAV: SiteNavItem[] = [
  { key: 'home', label: '首页', path: '/' },
  {
    key: 'products',
    label: '产品中心',
    path: '/aixue-ai',
    children: [
      { key: 'agents', label: '爱学AI学习智能体', path: '/aixue-ai' },
      { key: 'matrix', label: '爱学AI低龄段产品', path: '/aixue-phonics' },
      { key: 'explain', label: '爱学拍讲智能体', path: '/aixue-explain' },
      { key: 'tutor', label: '爱学智引平台', path: '/aixue-guide' },
      // { key: 'xiabao', label: '虾宝', path: '/aixue-xiabao' },
    ],
  },
  { key: 'about', label: '关于我们', path: '/aixue-about' },
  { key: 'careers', label: '加入我们', path: '/aixue-join' },
  // { key: 'downloads', label: '下载中心', path: '/aixue-download' },
];
